<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <div class="flex-item-two-columns">
        <div class="form-group">  
          <label for="{{ baseId }}-externalId" translate>External ID</label>
          <input
            id="{{ baseId }}-externalId"
            class="form-control"
            [ngClass]="{ error: showErrors(externalIdControl, isSubmitted), 'required': isRequired(externalIdControl) }"
            [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
            type="text"
            formControlName="externalId"
          />
          <div *ngIf="showErrors(externalIdControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
            {{ externalIdControl.errors | fcListValidation : 'ID' }}
          </div>
        </div>
      </div> 
      <div class="flex-item-two-columns">
        <div class="form-group">   
          <label for="{{ baseId }}-name" translate>Name</label>
          <input
            id="{{ baseId }}-name"
            class="form-control"
            [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
            [maxlength]="fcListValidation.validations.Name.MaxLength"
            [required]="fcListValidation.validations.Name.IsRequired"
            type="text"
            formControlName="name"
          />
          <div *ngIf="showErrors(nameControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
            {{ nameControl.errors | fcListValidation : 'Name' }}
          </div>
        </div>
      </div>   
    </div> 
    <section class="flex-row-generic" *ngIf="showNotes">
      <div class="form-group" name="notes-section">
        <label for="{{ baseId }}-notes" translate>Notes</label>
        <input
          id="{{ baseId }}-notes"
          class="form-control"
          [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Notes.MaxLength"
          formControlName="notes"
          rows="3"
        />
        <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
          {{ notesControl.errors | fcListValidation : 'Notes' }}
        </div>
      </div>
    </section>
    <section class="flex-row-generic" *ngIf="showJobSuccessHistoryDepth">
      <div class="form-group">
          <label for="{{ baseId }}-jobSuccessHistoryDepth" translate>Job Success History Depth</label>
        <input
          id="{{ baseId }}-jobSuccessHistoryDepth"
          class="form-control"
          [ngClass]="{ error: showErrors(jobSuccessHistoryDepthControl, isSubmitted), 'required': isRequired(jobSuccessHistoryDepthControl) }"
          type="number"
          [required]="fcListValidation.validations.JobSuccessHistoryDepth.IsRequired"
          formControlName="jobSuccessHistoryDepth"
        />
        <div *ngIf="showErrors(jobSuccessHistoryDepthControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
          {{ jobSuccessHistoryDepthControl.errors | fcListValidation : 'Job Success History Depth' }}
        </div>
      </div>
    </section>
    <div class="flex-row-generic">
      <div class="flex-item-two-columns">
        <div class="form-group">  
          <label for="{{ baseId }}-jobUid" translate>Job</label>
          <ap-findcontrol id="{{ baseId }}-id-job-findcontrol"
                      baseId="{{ baseId }}-job-findcontrol"
                      controlName="jobControl"
                      findControlDisplayName="Find Job"
                      [form]="form"
                      [disabled]="false"
                      [(selectedPks)]="selectedJobUid"
                      [findControlId]="FindControlIdService.ListJob"
                      [required]="fcListValidation.validations.JobUid.IsRequired"
                      [singleSelect]="true"
                      (chipsChange)="onJobPopulate($event)">
          </ap-findcontrol>
          <div *ngIf="showErrors(jobControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
            {{ jobControl.errors | fcListValidation : 'Job' }}
          </div> 
        </div>
      </div>   
    </div>
    <div class="flex-row-generic">
      <div class="flex-item-two-columns">
        <div class="form-group">  
          <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
        </div>
      </div>   
    </div> 
    <hr />
    <section class="flex-row-generic">
      <div class="flex-row-generic">
        <div class="flex-item-three-columns">
          <div class="form-group"> 
            <label for="{{ baseId }}-jobUid" translate>Perform This Job</label>
            <ap-findcontrol id="{{ baseId }}-id-job-schedule-time-base-findcontrol"
                      baseId="{{ baseId }}-job-schedule-time-base-findcontrol"
                      controlName="jobScheduleTimeBaseControl"
                      findControlDisplayName="Find Job Schedule Time Base"
                      [form]="form"
                      [disabled]="false"
                      [(selectedPks)]="selectedJobScheduleTimeBaseUid"
                      [required]="fcListValidation.validations.JobScheduleTimeBaseUid.IsRequired"
                      [findControlId]="FindControlIdService.ListJobScheduleTimeBase"
                      [singleSelect]="true"
                      (chipsChange)="onJobScheduleTimeBasePopulate($event)">
            </ap-findcontrol>
            <div *ngIf="showErrors(jobScheduleTimeBaseControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
              {{ jobScheduleTimeBaseControl.errors | fcListValidation : 'Time Basis' }}
            </div>
          </div>
        </div>
        <div class="flex-item-three-columns">
          <div class="form-group"> 
              <label for="{{ baseId }}-jobRepeatFrom" translate>Start Date</label>
              <ap-date-picker
                [baseId]= "baseId + '-job-repeat-interval-findcontrol'"
                [required]="false"
                [apDisableControl]="false"
                [showRequiredOnly]="false"
                [hidden]="false"
                [required]="fcListValidation.validations.JobRepeatFrom.IsRequired"
                [showLabel]="false"
                [formControl]="jobRepeatFromControl">
              </ap-date-picker>
              <div *ngIf="showErrors(jobRepeatFromControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
                {{ jobRepeatFromControl.errors | fcListValidation : 'Start Date' }}
              </div>
          </div>
        </div>
        <div class="flex-item-three-columns">
          <div class="form-group"> 
            <label for="{{ baseId }}-jobRepeatInterval" translate>At</label>
            <input
              id="{{ baseId }}-StartTime"
              class="form-control"
              [ngClass]="{ error: showErrors(startTimeControl, isSubmitted), 'required': isRequired(startTimeControl) }"
              [required]="fcListValidation.validations.JobRepeatFrom.IsRequired"
              type="time"
              formControlName="startTime"
            />
            <div *ngIf="showErrors(jobRepeatFromControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
              {{ jobRepeatFromControl.errors | fcListValidation : 'Start Time' }}
            </div>  
          </div>
        </div>   
      </div>  
      <div class="flex-row-generic">
        <ng-container [ngSwitch]="selectedJobScheduleTimeBaseUid[0]">
          <ng-container *ngSwitchCase="systemGuid.JobScheduleTimeBaseNthSecondUid">
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <label translate>Every</label>
              </div>
            </div>  
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-nth-second-findcontrol"
                  class="form-control"
                  type="number"
                  [max]="fcListValidation.validations.TimeBaseNthSecond.Max"
                  formControlName="timeBaseNthSecond"
                />
                <div *ngIf="showErrors(timeBaseNthSecondControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
                  {{ timeBaseNthSecondControl.errors | fcListValidation : 'nth Second' }}
                </div>
              </div>
            </div>  
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <label translate>Seconds</label>
              </div>
            </div>  
          </ng-container>
          <ng-container *ngSwitchCase="systemGuid.JobScheduleTimeBaseNthMinuteUid">
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <label translate>Every</label>
              </div>
            </div>
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-nth-minute-findcontrol"
                  class="form-control"
                  type="number"
                  [max]="fcListValidation.validations.TimeBaseNthMinute.Max"
                  formControlName="timeBaseNthMinute"
                />
                <div *ngIf="showErrors(timeBaseNthMinuteControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
                  {{ timeBaseNthMinuteControl.errors | fcListValidation : 'nth Minute' }}
                </div>
              </div>
            </div>
            <div class="flex-item-three-columns">
              <div class="form-group">      
                <label translate>Minutes</label>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="systemGuid.JobScheduleTimeBaseHourlyUid">
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-hourly-findcontrol"
                  class="form-control"
                  type="number"
                  [max]="fcListValidation.validations.TimeBaseHour.Max"
                  formControlName="timeBaseHour"
                />
                <div *ngIf="showErrors(timeBaseHourControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
                  {{ timeBaseHourControl.errors | fcListValidation : 'nth Hour' }}
                </div>
              </div>
            </div>
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <label translate>Minutes Past Every Hour</label>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="systemGuid.JobScheduleTimeBaseDailyUid">
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <mat-radio-group
                  id="{{ baseId }}-id-job-schedule-time-base-daily-type-findcontrol"
                  formControlName="timeBaseDailyType"
                  class="radio-group"
                >
                  <mat-radio-button value=0 translate checked >Every Day</mat-radio-button>
                  <mat-radio-button value=1 translate >Weekdays</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <label translate>At</label>
              </div>
            </div>
            <div class="flex-item-three-columns">
              <div class="form-group">  
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-daily-time-findcontrol"
                  class="form-control"
                  type="time"
                  formControlName="timeBaseDailyTime"
                />
              </div>
            </div>              
          </ng-container>
          <ng-container *ngSwitchCase="systemGuid.JobScheduleTimeBaseWeeklyUid">
            <div class="flex-item-three-columns">
              <div class="form-group"> 
                <label translate>Recur Every Week at</label>
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-weekly-time-findcontrol"
                  class="form-control"
                  type="time"
                  formControlName="timeBaseWeeklyTime"
                />          
              </div>
            </div>   
            <div class="">
              <div class="form-group">  
                <label translate>On</label>
                <div class="checkbox-group">
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-sunday-findcontrol"
                                formControlName="timeBaseWeeklySunday"
                                translate>Sunday
                  </mat-checkbox>
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-monday-findcontrol"
                                formControlName="timeBaseWeeklyMonday"
                                translate>Monday
                  </mat-checkbox>
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-tuesday-findcontrol"
                                formControlName="timeBaseWeeklyTuesday"
                                translate>Tuesday
                  </mat-checkbox>
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-wednesday-findcontrol"
                                formControlName="timeBaseWeeklyWednesday"
                                translate>Wednesday
                  </mat-checkbox>
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-thursday-findcontrol"
                                formControlName="timeBaseWeeklyThursday"
                                translate>Thursday
                  </mat-checkbox>
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-friday-findcontrol"
                                formControlName="timeBaseWeeklyFriday"
                                translate>Friday
                  </mat-checkbox>
                  <mat-checkbox id="{{ baseId }}-id-job-schedule-time-base-weekly-saturday-findcontrol"
                                formControlName="timeBaseWeeklySaturday"
                                translate>Saturday
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="systemGuid.JobScheduleTimeBaseMonthlyUid">
            <div class="flex-item-four-columns">
              <div class="form-group">  
                <label class="inline-label" translate>Day</label>
              </div>
            </div>  
            <div class="flex-item-four-columns">
              <div class="form-group">  
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-monthly-day-findcontrol"
                  class="form-control"
                  type="number"
                  [max]="fcListValidation.validations.TimeBaseMonthlyDayOfMonth.Max"
                  [min]="fcListValidation.validations.TimeBaseMonthlyDayOfMonth.Min"
                  formControlName="timeBaseMonthlyDayOfMonth"
                />
                <div *ngIf="showErrors(timeBaseMonthlyDayOfMonthControl, isSubmitted)" id="{{ baseId }}-warning-text-code" class="incorrect-input" translate>
                  {{ timeBaseMonthlyDayOfMonthControl.errors | fcListValidation : 'Day of Month' }}
                </div>
              </div>
            </div>  
            <div class="flex-item-four-columns">
              <div class="form-group">  
                <label translate>of Every Month at</label>
              </div>
            </div>  
            <div class="flex-item-four-columns">
              <div class="form-group">  
                <input
                  id="{{ baseId }}-id-job-schedule-time-base-monthly-time-findcontrol"
                  class="form-control"
                  type="time"
                  formControlName="timeBaseMonthlyTime"
                />
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </section>    
    <section class="flex-row-generic">
      <div class="form-group">
          <mat-checkbox id="{{ baseId }}-user-defined-checkbox" disabled="true" formControlName="userDefined" translate> User Defined </mat-checkbox>
      </div>
    </section>
    <section class="flex-row-generic">
      <div class="form-group">
          <mat-checkbox id="{{ baseId }}-run-immediately-checkbox" formControlName="runImmediately" translate> Run Immediately </mat-checkbox>
      </div>
    </section>
  </div>
</fc-general-modal>
